export const AFYA_IMARA_DOCUMENTS_FORM = 'afyaImara/documentsForm/';

export const AFYA_IMARA_DOCUMENTS_FORM_SET_VALUE = AFYA_IMARA_DOCUMENTS_FORM + 'setValue/';
export const AFYA_IMARA_DOCUMENTS_FORM_SET_VALID = AFYA_IMARA_DOCUMENTS_FORM + 'setValid/';

export const FORM_VALID_AFYA_IMARA_DOCUMENTS_FORM = 'afyaImara/documentsForm/transition/formValid';
export const FORM_INVALID_AFYA_IMARA_DOCUMENTS_FORM = 'afyaImara/documentsForm/transition/formInValid';

export const REINITIALIZE = 'afyaImara/documentsForm/state/reinitialize';

// Dropoff
export const DROP_OFF_LEAD_TRANSITION_DOCUMENTS_FORM = 'afyaImara/documentsForm/transition/dropOffLead';
export const dropOffLeadDocuments = (value) => ({
    type: DROP_OFF_LEAD_TRANSITION_DOCUMENTS_FORM,
    value,
});

export const transitionPersonalAccidentDocumentsForm = {
    formValid: () => ({
        type: FORM_VALID_AFYA_IMARA_DOCUMENTS_FORM,
    }),
    formInvalid: () => ({
        type: FORM_INVALID_AFYA_IMARA_DOCUMENTS_FORM,
    }),
};

// API Calls actions
export const API_PENDING_TRANSITION_DOCUMENTS_FORM = `${AFYA_IMARA_DOCUMENTS_FORM_SET_VALUE}/apiTransition/pending`;
export const API_SUCCESS_TRANSITION_DOCUMENTS_FORM = `${AFYA_IMARA_DOCUMENTS_FORM_SET_VALUE}/apiTransition/success`;
export const API_FAILURE_TRANSITION_DOCUMENTS_FORM = `${AFYA_IMARA_DOCUMENTS_FORM_SET_VALUE}/apiTransition/failure`;

export const apiTransitionDocumentsForm = {
    pending: () => ({
        type: API_PENDING_TRANSITION_DOCUMENTS_FORM,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_DOCUMENTS_FORM,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_DOCUMENTS_FORM,
    }),
};

//calculated Data
export const COLLECT_DOCUMENTS_FORM_DATA = AFYA_IMARA_DOCUMENTS_FORM_SET_VALUE + 'collectDocumentsData';
export const SUBMIT_DOCUMENTS_SUCCESS = AFYA_IMARA_DOCUMENTS_FORM_SET_VALUE + 'success';
export const SUBMIT_DOCUMENTS_FAILURE = AFYA_IMARA_DOCUMENTS_FORM_SET_VALUE + 'failure';

export const collectDocumentsData = () => ({
    type: COLLECT_DOCUMENTS_FORM_DATA,
});
export const submitDocumentsDataSuccess = (value) => ({
    type: SUBMIT_DOCUMENTS_SUCCESS,
    value,
});
export const submitDocumentsFailure = (error) => ({
    type: SUBMIT_DOCUMENTS_FAILURE,
    error,
});

// Form Values
export const ID_UPLOAD_SET_VALUE = AFYA_IMARA_DOCUMENTS_FORM_SET_VALUE + 'idUpload';
export const ID_UPLOAD_SET_VALID = AFYA_IMARA_DOCUMENTS_FORM_SET_VALID + 'idUpload';

export const KRA_PIN_UPLOAD_SET_VALUE = AFYA_IMARA_DOCUMENTS_FORM_SET_VALUE + 'kraPinUpload';
export const KRA_PIN_UPLOAD_SET_VALID = AFYA_IMARA_DOCUMENTS_FORM_SET_VALID + 'kraPinUpload';

export const BIRTH_CERTIFICATE_SET_VALUE = AFYA_IMARA_DOCUMENTS_FORM_SET_VALUE + 'birthCertificate';
export const BIRTH_CERTIFICATE_SET_VALID = AFYA_IMARA_DOCUMENTS_FORM_SET_VALID + 'birthCertificate';

export const SPOUSE_ID_SET_VALUE = AFYA_IMARA_DOCUMENTS_FORM_SET_VALUE + 'spouseIdDoc';

export const SPOUSE_ID_SET_VALID = AFYA_IMARA_DOCUMENTS_FORM_SET_VALID + 'spouseIdDoc';
// reset individual form value
export const ID_UPLOAD_RESET_VALUE = AFYA_IMARA_DOCUMENTS_FORM_SET_VALUE + 'reset/idUpload';
export const KRA_PIN_UPLOAD_RESET_VALUE = AFYA_IMARA_DOCUMENTS_FORM_SET_VALUE + 'reset/kraPinUpload';
export const BIRTH_CERTIFICATE_RESET_VALUE = AFYA_IMARA_DOCUMENTS_FORM_SET_VALUE + 'reset/birthCertificate';
export const SPOUSE_ID_RESET_VALUE = AFYA_IMARA_DOCUMENTS_FORM_SET_VALUE + 'reset/spouseIdDoc';

// ID upload action creators
export const setIdUploadValue = (value) => ({
    type: ID_UPLOAD_SET_VALUE,
    value,
});

export const setIdUploadValid = (error) => ({
    type: ID_UPLOAD_SET_VALID,
    error,
});

export const resetIdUploadValue = () => ({
    type: ID_UPLOAD_RESET_VALUE,
});

export const setKraPinUploadValue = (value) => ({
    type: KRA_PIN_UPLOAD_SET_VALUE,
    value,
});

export const setKraPinUploadValid = (error) => ({
    type: KRA_PIN_UPLOAD_SET_VALID,
    error,
});

export const resetKraPinUploadValue = () => ({
    type: KRA_PIN_UPLOAD_RESET_VALUE,
});

export const setBirthCertificateUploadValue = (value) => ({
    type: BIRTH_CERTIFICATE_SET_VALUE,
    value,
});

export const setBirthCertificateUploadValid = (error) => ({
    type: BIRTH_CERTIFICATE_SET_VALID,
    error,
});

export const resetBirthCertificateUploadValue = () => ({
    type: BIRTH_CERTIFICATE_RESET_VALUE,
});

export const setSpouseIdDocUploadValue = (value) => ({
    type: SPOUSE_ID_SET_VALUE,
    value,
});

export const setSpouseIdDocUploadValid = (error) => ({
    type: SPOUSE_ID_SET_VALID,
    error,
});

export const resetSpouseIdDocUploadValue = () => ({
    type: SPOUSE_ID_RESET_VALUE,
});

export const SPOUSE_VALID_SET_VALUE = AFYA_IMARA_DOCUMENTS_FORM_SET_VALUE + 'spouseValidDoc';
export const CHILDREN_VALID_SET_VALUE = AFYA_IMARA_DOCUMENTS_FORM_SET_VALUE + 'childrenValidDoc';
export const PERSONAL_VALID_SET_VALUE = AFYA_IMARA_DOCUMENTS_FORM_SET_VALUE + 'personalValidDoc';


export const setSpouseValidValue = (value) => ({
    type: SPOUSE_VALID_SET_VALUE,
    value,
});

export const setChildrenValidValue = (value) => ({
    type: CHILDREN_VALID_SET_VALUE,
    value,
});

export const setPersonalValidValue = (value) => ({
    type: PERSONAL_VALID_SET_VALUE,
    value,
});
